import Monolith from "components/node-types/monolith/monolith";

export default Monolith;
